import React from "react";
import ClientPageHeader from "./ClientPageHeader";

export default function ClientShiftsHeader() {
  return <ClientPageHeader title="Shifts" />;
}
